import React, { useCallback, useEffect, useState } from "react";
import { ReactComponent as SendButton } from "../../Global Icons/Send Button.svg";
import { useDispatch, useSelector } from "react-redux";
// import { getChatPaymentExecById } from "../../Redux/Actions/chatAction";
import { getChatListAdminById } from "../../Redux/Actions/chatAction";
import Socket from "../../Global Functions/socket";
import TextInput from "../../Global Functions/textInput";
import { useRef } from "react";
import { ReactComponent as Logo } from "../../Global Icons/ProptekLogo.svg";
import { MdPerson, MdEmail, MdPhone } from "react-icons/md";
import toast from "react-hot-toast";

const ChatComponentAdmin = ({
  selectedBookingId,
  chatWith = "builders",
  selectedPerson,
}) => {
  const dispatch = useDispatch();
  const [messages, setMessages] = useState([]);
  const [inputMessages, setInputMessages] = useState("");

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const messageListRef = useRef(null);

  const { individualChat } = useSelector((state) => state.chats || {});
  const { admin } = useSelector((state) => state.admin || {});

  const sendMessages = () => {
    if (!inputMessages?.trim()) return toast.error("Please enter a message!!");

    const messagePayload = {
      message: inputMessages,
      builder_id: chatWith === "builders" ? selectedBookingId : undefined,
      user_id: chatWith === "users" ? selectedBookingId : undefined,
      project_id: "67f8edfe9a1b8d002d117673",
      chat_with: chatWith,
      admin_id: admin?.data?._id || "",
    };
    Socket.emit("help-support-chat", messagePayload, (response) => {
      if (response) {
        setMessages((prev) => [...prev, messagePayload]);
      } else {
        toast.error(response.message || "Failed to send");
      }
    });
    setInputMessages("");
  };

  //memoised
  const fetchDetails = useCallback(
    (page, limit, selectedBookingId) => {
      if (!selectedBookingId) return;

      const chatData = {
        page,
        limit,
        ...(chatWith === "builders"
          ? { builder_id: selectedBookingId }
          : { user_id: selectedBookingId }),
      };

      dispatch(getChatListAdminById(chatData));
    },
    [chatWith, dispatch]
  );

  // console.log("selectedPerson", selectedPerson);

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize, selectedBookingId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBookingId]);

  useEffect(() => {
    if (individualChat?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: individualChat.total,
      }));
    }
  }, [individualChat]);

  useEffect(() => {
    if (Array.isArray(individualChat?.data)) {
      setMessages((prevMessages) =>
        pagination.current === 1
          ? individualChat.data
          : [...prevMessages, ...individualChat.data]
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [individualChat]);

  useEffect(() => {
    const messageList = messageListRef.current;

    const handleScroll = () => {
      if (messageList.scrollTop < 50 && messages.length < pagination.total) {
        // User scrolled near top, load older messages
        const nextPage = pagination.current + 1;
        setPagination((prev) => ({ ...prev, current: nextPage }));
        fetchDetails(nextPage, pagination.pageSize, selectedBookingId);
      }
    };

    if (messageList) {
      messageList.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (messageList) {
        messageList.removeEventListener("scroll", handleScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messages, pagination.total, selectedBookingId]);

  useEffect(() => {
    const listener = (message) => {
      setMessages((prev) => [message, ...prev]);
    };

    if (selectedBookingId) {
      Socket.on(`${selectedBookingId}`, listener);

      return () => {
        Socket.off(`${selectedBookingId}`, listener);
      };
    }
  }, [selectedBookingId]);

  return (
    <div className="chat-window">
      <div className="flex-container flex-justify-between align-center">
        <h3 style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "308px" }}>
          {selectedPerson ? (
            typeof selectedPerson === "object" ? (
              <>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <MdPerson size={20} />
                  {selectedPerson.name}
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <MdEmail size={20} />
                  {selectedPerson.email}
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <MdPhone size={20} />
                  {selectedPerson.countryCode} {selectedPerson.contactNumber}
                </div>
              </>
            ) : (
              selectedPerson
            )
          ) : (
            "Select a chat to start messaging"
          )}
        </h3>
      </div>
      <hr />
      <div className="message-list" ref={messageListRef}>
        {selectedBookingId &&
          messages.map((chat, index) => {
            const isAdmin = chat?.admin_id;
            return (
              <div
                className={`message_div ${
                  isAdmin ? "admin-message" : "user-message"
                }`}
                key={index}
              >
                <div className="message-content">
                  <h2>{chat?.message}</h2>
                  <p>{new Date(chat?.created_at).toLocaleString()}</p>
                </div>
              </div>
            );
          })}
      </div>
      <div className="input-area">
        <TextInput
          value={inputMessages}
          placeholder="Enter Message"
          onChange={(event) => setInputMessages(event.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              sendMessages();
            }
          }}
        />
        <SendButton
          style={{ cursor: "pointer", width: "60px", height: "60px" }}
          onClick={sendMessages}
        />
      </div>
    </div>
  );
};

export default ChatComponentAdmin;
